// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"main-section_mainSection__6lGGf","desktop":"main-section_desktop__7ix2K","mobile":"main-section_mobile__bJ_8K"};